module.exports = __webpack_public_path__ + "img/VMCTopManagement.039bfef6.jpg";